import { render, staticRenderFns } from "./ResourceBookingBoxButton.vue?vue&type=template&id=03307668&"
import script from "./ResourceBookingBoxButton.vue?vue&type=script&lang=js&"
export * from "./ResourceBookingBoxButton.vue?vue&type=script&lang=js&"
import style0 from "./ResourceBookingBoxButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports